"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Stainlessproperties() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const specs = [{
    value: "0.001\"",
    unit: "TOLERANCE",
    description: "Precision laser cutting ensuring exact dimensions for every industrial component.",
    position: "top-left"
  }, {
    value: "UL",
    unit: "CERTIFIED",
    description: "Compliance with rigorous safety standards for all electrical and panel labeling.",
    position: "top-right"
  }, {
    value: "UV",
    unit: "RESISTANT",
    description: "Engineered materials designed to withstand harsh outdoor environments and sunlight.",
    position: "bottom-left"
  }, {
    value: "24/7",
    unit: "PRODUCTION",
    description: "High-capacity manufacturing workflows optimized for rapid turnaround and delivery.",
    position: "bottom-right"
  }];
  const marqueeTerms = ["PRECISION", "DURABILITY", "COMPLIANCE", "INDUSTRIAL", "LASER", "QUALITY"];
  const marqueeLoop = [...marqueeTerms, ...marqueeTerms, ...marqueeTerms];
  return <section data-section-id="3457" id="stainlessproperties" className="bg-background text-foreground py-24 md:py-40 px-4 md:px-8 overflow-hidden relative">
      {}
      <div ref={headerRef} className={`max-w-[800px] mx-auto text-center mb-20 md:mb-32 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="hidden sm:block h-px w-16" style={{
          backgroundColor: "var(--primary)"
        }} />
          <span className="font-default text-xs uppercase tracking-[0.3em]" style={{
          color: "var(--primary)"
        }}>
            The Stainless Standard
          </span>
          <span className="hidden sm:block h-px w-16" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>
        <h2 className="font-default font-black text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
          Technical{" "}
          <span className="block italic font-serif font-light text-transparent" style={{
          WebkitTextStroke: "1px var(--foreground)"
        }}>
            Specifications
          </span>
        </h2>
      </div>

      {}
      <div ref={gridRef} className={`relative max-w-7xl mx-auto transition-all duration-1000 delay-200 ${gridVisible ? "opacity-100" : "opacity-0"}`}>
        {}
        <div className="hidden lg:grid grid-cols-[1fr_auto_1fr] gap-8 items-center">
          {}
          <div className="flex flex-col gap-12">
            {specs.filter(s => s.position.startsWith("top-left") || s.position.startsWith("bottom-left")).map((spec, i) => <SpecCard key={i} data-index={i} spec={spec} align="right" />)}
          </div>

          {}
          <div className="relative flex items-center justify-center px-4">
            <Blueprint />
          </div>

          {}
          <div className="flex flex-col gap-12">
            {specs.filter(s => s.position.startsWith("top-right") || s.position.startsWith("bottom-right")).map((spec, i) => <SpecCard key={i} data-index={i} spec={spec} align="left" />)}
          </div>
        </div>

        {}
        <div className="lg:hidden flex flex-col gap-12 items-center">
          <div className="w-full max-w-sm">
            <Blueprint />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            {specs.map((spec, i) => <div data-index={i} key={i}>
                <SpecCard spec={spec} align="left" />
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="mt-24 md:mt-32 border-y overflow-hidden -mx-4 md:-mx-8" style={{
      borderColor: "var(--primary)"
    }}>
        <div className="flex whitespace-nowrap animate-marquee py-5">
          {marqueeLoop.map((term, i) => <span data-index={i} key={i} className="font-default uppercase text-sm tracking-[0.4em] mx-8 flex items-center gap-8" style={{
          color: "var(--muted-foreground)"
        }}>
              {term}
              <span className="inline-block h-1 w-1" style={{
            backgroundColor: "var(--primary)"
          }} />
            </span>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
      `}</style>
    </section>;
}
function SpecCard({
  spec,
  align,
  ...rest
}: {
  spec: {
    value: string;
    unit: string;
    description: string;
  };
  align: "left" | "right";
  [key: string]: any;
}) {
  return <div {...rest} className="relative backdrop-blur-sm p-8 w-full max-w-[320px] mx-auto shadow-lg border transition-all duration-300 hover:-translate-y-1" style={{
    backgroundColor: "var(--card)",
    borderColor: "var(--border)"
  }}>
      {}
      <span className="absolute top-0 left-0 w-3 h-px" style={{
      backgroundColor: "var(--primary)"
    }} />
      <span className="absolute top-0 left-0 w-px h-3" style={{
      backgroundColor: "var(--primary)"
    }} />
      <span className="absolute bottom-0 right-0 w-3 h-px" style={{
      backgroundColor: "var(--primary)"
    }} />
      <span className="absolute bottom-0 right-0 w-px h-3" style={{
      backgroundColor: "var(--primary)"
    }} />

      <div className={`flex flex-col ${align === "right" ? "items-end text-right" : "items-start text-left"}`}>
        <div className="font-default font-black text-6xl md:text-7xl leading-none tabular-nums tracking-tight" style={{
        color: "var(--primary)"
      }}>
          {spec.value}
        </div>
        <div className="font-default text-[11px] uppercase tracking-[0.25em] mt-3" style={{
        color: "var(--muted-foreground)"
      }}>
          {spec.unit}
        </div>
        <div className="h-px w-12 my-4" style={{
        backgroundColor: "var(--border)"
      }} />
        <p className="font-default text-sm leading-relaxed" style={{
        color: "var(--foreground)"
      }}>
          {spec.description}
        </p>
      </div>
    </div>;
}
function Blueprint() {
  return <div className="relative w-full max-w-[300px] mx-auto">
      <svg viewBox="0 0 300 700" className="w-full h-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
        {}
        <line x1="150" y1="20" x2="150" y2="680" stroke="var(--border)" strokeWidth="0.5" strokeDasharray="2 4" />

        {}
        <path d="M 150 40 L 165 110 L 175 220 L 178 340 L 175 420 L 168 460 L 150 470 L 132 460 L 125 420 L 122 340 L 125 220 L 135 110 Z" stroke="var(--foreground)" strokeWidth="1" fill="none" />

        {}
        <line x1="150" y1="40" x2="150" y2="470" stroke="var(--foreground)" strokeWidth="0.5" opacity="0.4" />

        {}
        <path d="M 132 200 Q 150 195 168 200" stroke="var(--primary)" strokeWidth="0.4" opacity="0.5" fill="none" />
        <path d="M 130 260 Q 150 255 170 260" stroke="var(--primary)" strokeWidth="0.4" opacity="0.5" fill="none" />
        <path d="M 128 320 Q 150 315 172 320" stroke="var(--primary)" strokeWidth="0.4" opacity="0.5" fill="none" />
        <path d="M 128 380 Q 150 375 172 380" stroke="var(--primary)" strokeWidth="0.4" opacity="0.5" fill="none" />

        {}
        <rect x="138" y="470" width="24" height="18" stroke="var(--foreground)" strokeWidth="1" fill="none" />

        {}
        <path d="M 134 488 L 134 640 Q 134 660 150 660 Q 166 660 166 640 L 166 488 Z" stroke="var(--foreground)" strokeWidth="1" fill="none" />

        {}
        <circle cx="150" cy="560" r="3" stroke="var(--foreground)" strokeWidth="0.5" fill="none" />

        {}
        <circle cx="150" cy="480" r="6" stroke="var(--primary)" strokeWidth="1" fill="none" />
        <circle cx="150" cy="480" r="1.5" fill="var(--primary)" />

        {}
        <line x1="178" y1="40" x2="220" y2="40" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="225" y="38" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          EDGE
        </text>
        <text x="225" y="48" fill="var(--muted-foreground)" fontSize="6" fontFamily="sans-serif">
          0.01mm
        </text>

        {}
        <line x1="60" y1="40" x2="100" y2="40" stroke="var(--primary)" strokeWidth="0.5" />
        <line x1="60" y1="470" x2="100" y2="470" stroke="var(--primary)" strokeWidth="0.5" />
        <line x1="80" y1="40" x2="80" y2="470" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="20" y="258" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          SCALE
        </text>

        {}
        <line x1="178" y1="430" x2="240" y2="430" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="245" y="428" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          ISO
        </text>
        <text x="245" y="438" fill="var(--muted-foreground)" fontSize="6" fontFamily="sans-serif">
          STD
        </text>

        {}
        <line x1="156" y1="480" x2="240" y2="495" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="245" y="497" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          ALIGN
        </text>

        {}
        <line x1="134" y1="580" x2="60" y2="580" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="10" y="578" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          BASE
        </text>

        {}
        <line x1="170" y1="488" x2="200" y2="488" stroke="var(--primary)" strokeWidth="0.5" />
        <line x1="170" y1="660" x2="200" y2="660" stroke="var(--primary)" strokeWidth="0.5" />
        <line x1="185" y1="488" x2="185" y2="660" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="3 2" />
        <text x="205" y="578" fill="var(--primary)" fontSize="8" fontFamily="sans-serif" letterSpacing="1">
          150mm
        </text>

        {}
        <text x="150" y="680" fill="var(--muted-foreground)" fontSize="7" fontFamily="sans-serif" letterSpacing="2" textAnchor="middle">
          INDUSTRIAL / SPEC
        </text>
      </svg>
    </div>;
}